import { __rest } from "tslib";
import React from 'react';
import ButtonIcon from './button-icon';
import { cn, dataAttr, mergeProps } from '~/utils';
import { button } from './button.css';
import { useButton, useHover, useMergeRefs } from '~/hooks';
const BUTTON_NAME = 'vulcanui-button';
const Button = React.forwardRef((props, forwardedRef) => {
    const { children, className, disabled = false, color = 'default', variant = 'solid', rounded = false, shadow = false, startContent, endContent, auto = false, as: Comp = 'button', type = 'button', role = 'button', fullWidth = false } = props, restProps = __rest(props, ["children", "className", "disabled", "color", "variant", "rounded", "shadow", "startContent", "endContent", "auto", "as", "type", "role", "fullWidth"]);
    const buttonRef = React.useRef(null);
    const ref = useMergeRefs([forwardedRef, buttonRef]);
    const { buttonProps, isPressed: pressed } = useButton(Object.assign({ isDisabled: disabled, type, elementType: Comp }, restProps), buttonRef);
    const { hoverProps, isHovered: hovered } = useHover(Object.assign({ isDisabled: disabled }, restProps));
    return (React.createElement(Comp, Object.assign({ className: cn(BUTTON_NAME, className, button({ color, variant, auto, rounded, shadow, disabled, fullWidth, pressed, hovered })), ref: ref, role: role, "data-hovered": dataAttr(hovered), "data-pressed": dataAttr(pressed), "data-disabled": dataAttr(disabled) }, mergeProps(buttonProps, hoverProps)),
        startContent && React.createElement(ButtonIcon, null, startContent),
        children,
        endContent && React.createElement(ButtonIcon, null, endContent)));
});
Button.displayName = 'Button';
Button.toString = () => `.${BUTTON_NAME}`;
export default Button;
//# sourceMappingURL=button.js.map